<template>
  <div class="addevent eventdata addeventcourse">
    <b-form @submit.prevent="onSubmit">
      <input type="hidden" name="client" v-model="client_name" />
      <input type="hidden" name="event_type" v-model="event_type" />

      <b-card no-body class="p-3">
        <template #header>
          <b-card-sub-title class="my-0 card-subtitle-doom-yoga">{{
            action == "create" ? "New Course" : "Course Info"
          }}</b-card-sub-title>
        </template>

        <b-card-body class="pt-0">
           <EventBasicData
            :client_name="client_name"
            :field_name="'course'"
            :event_name.sync="course_name"
            :event_description.sync="course_description"
            :is_event_in_person.sync="is_course_in_person"
            :is_event_recurring.sync="is_course_recurring"
            :cover_image.sync="cover_image"
            :preview.sync="preview"
            :cover_image_id.sync="cover_image_id"
          />
       
          <b-row>
            <b-col md="7" v-if="is_course_recurring == 1">
              <b-row>
                <b-col md="6">
                  <b-form-group
                    :class="{
                      'form-group-vselect-doomyoga': client_name == 'DY',
                    }"
                    label="Recurrence"
                    label-for="recurrence"
                    :recurrence="recurrence"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <v-select
                      :options="recurrence_options"
                      name="recurrence"
                      title="recurrence"
                      v-model="recurrence"
                      placeholder="Select recurrence"
                      @input="changeRecurrence"
                      :reduce="(item) => item.code"
                      required
                      :clearable="false"
                    ></v-select
                  ></b-form-group>
                </b-col>
                <b-col
                  md="6"
                  v-if="
                    recurrence.code == 'day' ||
                    recurrence == 'day' ||
                    recurrence.code == 'week' ||
                    recurrence == 'week'
                  "
                >
                  <b-form-group
                    :class="{
                      'form-group-vselect-doomyoga': client_name == 'DY',
                    }"
                    label="Repeat every"
                    label-for="repeat"
                    :repeat="repeat"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <v-select
                      :options="optionsRecurrenceDaily"
                      name="repeat"
                      title="repeat"
                      v-model="repeat"
                      placeholder="Select repeat every"
                      class="repeatEverySelect"
                      :clearable="false"
                      required
                    ></v-select>
                    <span
                      class="repeatEverySpan"
                      v-if="recurrence.code == 'day' || recurrence == 'day'"
                      >day
                    </span>
                    <span
                      class="repeatEverySpan"
                      v-if="recurrence.code == 'week' || recurrence == 'week'"
                      >week
                    </span>
                  </b-form-group>
                </b-col>
                <b-col
                  md="6"
                  v-if="recurrence.code == 'month' || recurrence == 'month'"
                >
                  <b-form-group
                    :class="{
                      'form-group-vselect-doomyoga': client_name == 'DY',
                    }"
                    label="Repeat every"
                    label-for="repeat"
                    :repeat="repeat"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <v-select
                      :options="optionsRecurrenceMonthly"
                      name="repeat"
                      title="repeat"
                      v-model="repeat"
                      placeholder="Select repeat every"
                      class="repeatEverySelect"
                      required
                      :clearable="false"
                    ></v-select>
                    <span class="repeatEverySpan">month </span>
                  </b-form-group>
                </b-col>
              </b-row></b-col
            ></b-row
          >
          <!-- {{ recurrence }} --- {{ repeat }} --- {{ occurs_on }} -- {{occurs_on_month}} -->
          <b-row v-if="recurrence.code == 'week' || recurrence == 'week'">
            <b-col md="6">
              <b-row>
                <b-col>
                  <b-form-group
                    class="form-group-checkbox-group"
                    :class="{
                      'form-group-checkbox-group-doomyoga': client_name == 'DY',
                    }"
                    label="Occurs on"
                    v-slot="{ ariaDescribedby }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_occurs_on"
                    >
                      Please select day(s)
                    </p>
                    <b-form-checkbox-group
                      id="occursOnCheckboxGroup"
                      v-model="occurs_on"
                      :options="occurs_on_days"
                      :aria-describedby="ariaDescribedby"
                      name="occurs_on"
                    ></b-form-checkbox-group> </b-form-group
                ></b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-if="recurrence.code == 'month' || recurrence == 'month'">
            <b-col md="6">
              <b-row>
                <b-col>
                  <b-form-group
                    :class="{
                      'form-group-vselect-doomyoga': client_name == 'DY',
                    }"
                    label="Occurs on"
                    label-for="occurs_on_month"
                    :occurs_on_month="occurs_on_month"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_occurs_on_month"
                    >
                      Please select day of month
                    </p>
                    <span class="repeatEverySpan">Day </span>

                    <v-select
                      :options="occurs_on_day_month"
                      name="occurs_on_month"
                      title="occurs_on_month"
                      v-model="occurs_on_month"
                      placeholder="Select day of month"
                      class="repeatEverySelect"
                      style="width: auto"
                      required
                      :clearable="false"
                    ></v-select>
                    <span class="repeatEverySpan"> of the month </span>
                  </b-form-group></b-col
                >
              </b-row>
            </b-col>
          </b-row>
          <!-- {{ is_course_recurring }} -- {{ recurrence }} -- {{ repeat }} --
          {{ occurs_on }} -- {{ occurs_on_month }} -->
          <b-row>
            <b-col
              md="6"
              v-if="
                is_course_recurring == 1 &&
                recurrence.code != 'no_fixed_time' &&
                recurrence != 'no_fixed_time'
              "
            >
              <b-row>
                <b-col>
                  <b-form-group
                    label="Start date"
                    label-for="course_start_date"
                    :course_start_date="course_start_date"
                    class="form-group-event-date"
                    :class="{
                      'm-date-picker-doomyoga': client_name == 'DY',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_start_date"
                    >
                      Please select date
                    </p>
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_select_start_date"
                    >
                      Please select future date
                    </p>
                    <mDatePicker
                      v-model="course_start_date"
                      :multi="multidate"
                      :format="formatDate"
                      lang="en"
                      :disp="[
                        'Sun',
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                        '',
                        '',
                        'Cancel',
                        'OK',
                      ]"
                    ></mDatePicker>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="End date"
                    label-for="course_end_date"
                    :course_end_date="course_end_date"
                    class="form-group-event-date"
                    :class="{
                      'm-date-picker-doomyoga': client_name == 'DY',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_end_date"
                    >
                      Please select date
                    </p>
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_select_end_date"
                    >
                      Please select end date after start date
                    </p>
                    <mDatePicker
                      v-model="course_end_date"
                      :multi="multidate"
                      :format="formatDate"
                      lang="en"
                      :disp="[
                        'Sun',
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                        '',
                        '',
                        'Cancel',
                        'OK',
                      ]"
                    ></mDatePicker>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              md="6"
              v-else-if="
                is_course_recurring == null ||
                is_course_recurring == 0 ||
                recurrence.code == 'no_fixed_time' ||
                recurrence == 'no_fixed_time'
              "
            >
              <b-row>
                <b-col>
                  <b-form-group
                    label="Course date"
                    label-for="course_date"
                    :course_date="course_date"
                    class="form-group-event-date"
                    :class="{
                      'm-date-picker-doomyoga': client_name == 'DY',
                    }"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_date"
                    >
                      Please select date
                    </p>
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_select_date"
                    >
                      Please select future date(s)
                    </p>
                    <mDatePicker
                      v-model="course_date"
                      :format="formatDate"
                      :multi="multidate"
                      lang="en"
                      :disp="[
                        'Sun',
                        'Mon',
                        'Tue',
                        'Wed',
                        'Thu',
                        'Fri',
                        'Sat',
                        '',
                        '',
                        'Cancel',
                        'OK',
                      ]"
                    ></mDatePicker>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="6">
              <b-row>
                <b-col>
                  <b-form-group
                    label="Course time"
                    class="form-group-event-time"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                      'form-label-mid': client_name == 'MID',
                    }"
                  >
                    <p
                      class="error_validation_message_p_dy mx-0"
                      v-if="invalid_time"
                    >
                      Please select time
                    </p>
                    <b-row>
                      <b-col class="pr-0">
                        <b-form-group
                          label="From"
                          label-for="course_from_time"
                          class="form-group-small-time"
                          label-cols-xl="3"
                          label-cols-md="3"
                          content-cols-xl="9"
                          content-cols-md="9"
                          :class="{
                            'form-group-time-doomyoga': client_name == 'DY',
                          }"
                          :label-class="{
                            'form-label-doomyoga': client_name == 'DY',
                          }"
                          ><b-form-timepicker
                            v-model="course_from_time"
                            locale="en"
                            placeholder="Select time"
                            minutes-step="10"
                          ></b-form-timepicker
                        ></b-form-group>
                      </b-col>
                      <b-col class="pl-0">
                        <b-form-group
                          label="To"
                          label-for="course_to_time"
                          class="form-group-small-time"
                          label-cols-xl="3"
                          label-cols-md="3"
                          content-cols-xl="9"
                          content-cols-md="9"
                          :class="{
                            'form-group-time-doomyoga': client_name == 'DY',
                          }"
                          :label-class="{
                            'form-label-doomyoga': client_name == 'DY',
                          }"
                        >
                          <b-form-timepicker
                            v-model="course_to_time"
                            locale="en"
                            placeholder="Select time"
                            minutes-step="10"
                          ></b-form-timepicker> </b-form-group></b-col
                    ></b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="7">
              <b-row>
                <b-col md="12">
                  <b-form-group
                    label="Capacity per session"
                    label-for="capacity_per_session"
                    :capacity_per_session="capacity_per_session"
                    class="capacitySessionDiv"
                    :label-class="{
                      'form-label-doomyoga': client_name == 'DY',
                    }"
                  >
                    <b-form-input
                      id="capacity_per_session"
                      v-bind:class="{
                        'form-control-doomyoga': client_name == 'DY',
                      }"
                      type="number"
                      min="1"
                      v-model="capacity_per_session"
                      :capacity_per_session="capacity_per_session"
                      required
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          
          <!-- {{ recurrence }} -- {{ repeat }} -- {{ occurs_on }} --
          {{ occurs_on_month }}
          <br />
          {{ course_start_date }} -- {{ course_end_date }} <br/>
          {{course_from_time}} -- {{course_to_time}} -->
        </b-card-body>
      </b-card>
      <event-payment
        :price_per_session.sync="price_per_session"
        :amount.sync="amount"
        :invalid_session_price="invalid_session_price"
        client_name="DY"
      />
      <event-location
        :location.sync="location"
        :invalid_location="invalid_location"
        client_name="DY"
        :locations="locations"
      />
      <b-row>
        <b-col lg="3" offset-lg="9" md="4" offset-md="8" sm="6" offset-sm="6">
          <b-button
            type="submit"
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100"
            v-if="!is_loading"
          >
            {{ action }} Course
          </b-button>
          <b-button
            type="button"
            disabled
            variant="doomyoga-primary"
            class="btn-bumblebee btn-doomyoga btn-doom-yoga-submit w-100"
            v-else
          >
            <b-spinner small label="Small Spinner" variant="light"></b-spinner>
            Loading
          </b-button>
        </b-col></b-row
      >
    </b-form>
  </div>
</template>

<script>
import EventBasicData from '@/components/events/BasicData.vue'
import EventPayment from "@/components/events/Payment.vue";
import EventLocation from "@/components/events/Location.vue";
import mDatePicker from "@/components/multi-date-picker/multiDatePicker.vue";
import $ from "jquery";
import axios from "axios";
import moment from "moment";

export default {
  name: "EventCourseInfo",
  components: {EventBasicData, EventLocation, EventPayment, mDatePicker },
  props: ["action"],
  data() {
    return {
      client_name: "DY",
      event_type: "course",

      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],

      course_name: "",
      course_description: "",
      is_course_in_person: "",
      cover_image: null,
      preview: null,
      cover_image_id: null,
      capacity_per_session: null,

      location: "",
      invalid_location: false,
      price_per_session: "",
      amount: "",
      invalid_session_price: false,

      course_from_time: "",
      course_to_time: "",
      invalid_time: false,

      recurrence_options: [
        { label: "Daily", code: "day" },
        { label: "Weekly", code: "week" },
        { label: "Monthly", code: "month" },
        { label: "No fixed time", code: "no_fixed_time" },
      ],
      occurs_on_days: [
        { text: "Sun", value: "Sunday" },
        { text: "Mon", value: "Monday" },
        { text: "Tue", value: "Tuesday" },
        { text: "Wed", value: "Wednesday" },
        { text: "Thu", value: "Thursday" },
        { text: "Fri", value: "Friday" },
        { text: "Sat", value: "Saturday" },
      ],

      is_course_recurring: null,

      course_date: null,
      multidate: false,
      invalid_date: false,
      invalid_select_date: false,
      course_start_date: null,
      invalid_start_date: false,
      invalid_select_start_date: false,
      course_end_date: null,
      invalid_end_date: false,
      invalid_select_end_date: false,

      recurrence: "",

      optionsRecurrenceDaily: [1, 2, 3, 4, 5, 6, 7],
      optionsRecurrenceMonthly: [1, 2, 3],
      repeat: null,
      invalid_occurs_on: false,
      occurs_on: [],

      occurs_on_day_month: [],
      occurs_on_month: null,
      invalid_occurs_on_month: false,

      is_loading: false,
      swal_confirm_button_class: "",
      swal_container_class: "",
    };
  },
  watch: {
    course_date: function (val) {
      console.log(val);
      let current_date = new Date();
      current_date.setHours(0);
      current_date.setMinutes(0);
      current_date.setSeconds(0);
      current_date.setMilliseconds(0);
      console.log(current_date);
      current_date = current_date.getTime();
      console.log(current_date);
      console.log(new Date(val).getTime());
      console.log(new Date(val).getTime() - current_date);

      if (
        this.course_date == null ||
        this.course_date == "" ||
        (Array.isArray(this.course_date) && this.course_date.length == 0)
      ) {
      } else {
        if (this.multidate == false) {
          var diff = new Date(val).getTime() - current_date;
          if (diff < 0) {
            this.invalid_select_date = true;
          } else {
            this.invalid_select_date = false;
          }
        } else {
          for (var i = 0; i < this.course_date.length; i++) {
            var diff = new Date(this.course_date[i]).getTime() - current_date;
            if (diff < 0) {
              this.invalid_select_date = true;
              break;
            }
            if (i == this.course_date.length - 1) {
              this.invalid_select_date = false;
            }
          }
        }
      }
    },
    course_start_date: function (val) {
      console.log(val);
      let current_date = new Date();
      current_date.setHours(0);
      current_date.setMinutes(0);
      current_date.setSeconds(0);
      current_date.setMilliseconds(0);
      console.log(current_date);
      current_date = current_date.getTime();
      console.log(current_date);
      console.log(new Date(val).getTime());
      console.log(new Date(val).getTime() - current_date);

      if (this.course_start_date != null && this.course_start_date != "") {
        var diff = new Date(val).getTime() - current_date;
        if (diff < 0) {
          this.invalid_select_start_date = true;
        } else {
          this.invalid_select_start_date = false;
        }
      }
    },
    course_end_date: function (val) {
      console.log(val);

      if (
        (this.course_start_date != null &&
          this.course_start_date != "" &&
          this.course_end_date != null) ||
        this.course_end_date != ""
      ) {
        var diff =
          new Date(this.course_end_date).getTime() -
          new Date(this.course_start_date).getTime();
        if (diff <= 0) {
          this.invalid_select_end_date = true;
        } else {
          this.invalid_select_end_date = false;
        }
      }
    },
  },
  mounted() {
    this.occurs_on_day_month = Array.from({ length: 31 }, (_, i) => i + 1);

    // console.log(JSON.parse(window.localStorage.getItem("user")));
    // console.log(this.client_name);
    if (this.client_name == "DY") {
      this.swal_confirm_button_class =
        "btn btn-bumblebee btn-doomyoga  btn-doomyoga-primary";
      this.swal_container_class = "swal-container-dy";
    }

    if (this.action === "update") {
      axios
        .get("event/events/" + this.$route.params.id, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          // this.events = response.data;
          this.setEventData(response.data);
        });

      console.log("update event id " + this.$route.params.id);
      this.event_id = this.$route.params.id;
    }
  },
  methods: {
    setEventData(event) {
      console.log("in set event data ");
      console.log(event);
      this.course_name = event.name;
      this.course_description = event.description;
      this.preview = event.cover.path;

      this.course_from_time = event.from;
      this.course_to_time = event.to;
      this.capacity_per_session = event.capacity;

      this.price_per_session = event.price_type;
      if (event.price_type === "fixed") {
        this.amount = event.price;
      }

      if (event.location_type === "online") {
        this.location = event.address;
      }

      this.is_course_in_person = event.is_person;
      this.is_course_recurring = event.is_recurring;
      // this.multidate = this.is_course_recurring == 1;

      if (this.is_course_recurring == 0) {
        this.course_date = new Date(event.dates[0]);
        this.course_date.setHours(0);
        this.course_date.setMinutes(0);
        this.course_date.setSeconds(0);
        this.course_date.setMilliseconds(0);
        this.multidate = false;
      } else {
        if (event.dates != null) {
          this.multidate = true;
          console.log(event.dates);
          let dates = [];
          event.dates.forEach((item) => {
            console.log(item);
            let datetemp = new Date(item);
            datetemp.setHours(0);
            datetemp.setMinutes(0);
            datetemp.setSeconds(0);
            datetemp.setMilliseconds(0);
            dates.push(datetemp);
          });
          console.log(dates);
          this.course_date = dates;
        }
        if (event.start_date != null) {
          this.multidate = false;
          console.log(new Date());
          console.log(moment(event.start_date, "DD-MM-yyyy").toDate());
          console.log(moment(event.end_date, "DD-MM-yyyy").toDate());
          this.course_start_date = moment(
            event.start_date,
            "DD-MM-yyyy"
          ).toDate();
          this.course_end_date = moment(event.end_date, "DD-MM-yyyy").toDate();
        }
        this.recurrence = event.recurrence;
        if (event.recurrence != "no_fixed_time") {
          this.repeat = event.repeat_every;
          if (event.recurrence == "week") {
            this.occurs_on = event.week_days;
          }
          if (event.recurrence == "month") {
            this.occurs_on_month = event.month_days[0];
          }
        }
      }
    },
    formatDate(date) {
      console.log(date);
      //  return date.toLocaleDateString();

      let formattedDate =
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
      // console.log(formattedDate);
      return formattedDate;
    },
    previewImage: function (event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.cover_image = input.files[0];
      }
    },
    addFile(id) {
      console.log("click file " + id);
      $("#" + id).click();
    },
    changeRecurrence() {
      // this.recurrence = this.recurrence.code;
      console.log(
        "change recurrence ",
        this.recurrence,
        this.is_course_recurring
      );
      if (this.recurrence == null) {
        this.repeat = null;
        this.occurs_on = [];
        this.occurs_on_month = null;
      } else {
        console.log(
          "change recurrence eeee",
          this.recurrence,
          this.is_course_recurring
        );
        if (
          this.recurrence == "no_fixed_time" ||
          this.recurrence.code == "no_fixed_time"
        ) {
          console.log(this.recurrence, this.course_date, this.multidate);
          this.course_date = [];
          this.multidate = true;
          console.log(this.recurrence, this.course_date, this.multidate);
        } else if (
          this.recurrence != "no_fixed_time" ||
          this.recurrence.code != "no_fixed_time" ||
          this.is_course_recurring == 0
        ) {
          console.log(
            "else",
            this.recurrence,
            this.course_date,
            this.multidate
          );

          this.course_date = null;
          this.multidate = false;
          if (this.recurrence == "day" || this.recurrence.code == "day") {
            this.repeat = 1;
            this.occurs_on = [];
            this.occurs_on_month = null;
          } else if (
            this.recurrence == "week" ||
            this.recurrence.code == "week"
          ) {
            this.repeat = 1;
            this.occurs_on = [];
            this.occurs_on_month = null;
          } else if (
            this.recurrence == "month" ||
            this.recurrence.code == "month"
          ) {
            this.repeat = 1;
            this.occurs_on = [];
            this.occurs_on_month = null;
          }
        }
      }
      console.log(this.recurrence, this.course_date, this.multidate);
    },
    clickIsRecuring(val) {
      //{{is_course_recurring}} -- {{recurrence}} -- {{repeat}} -- {{occurs_on}} -- {{occurs_on_month}}
      if (val == 0) {
        this.course_date = null;
        this.multidate = false;
        this.recurrence = "";
        this.repeat = null;
      } else {
        this.course_date = null;
        this.multidate = false;
        this.recurrence = "day";
        this.repeat = 1;
      }
    },
    checkValidation() {
      console.log("--------- in check validation -----");
      console.log(this.client_name, this.event_type);
      console.log(this.course_name);
      console.log(this.course_description);
      console.log(this.is_course_in_person, this.capacity_per_session);
      console.log(this.location);
      console.log(this.price_per_session, this.amount);
      console.log(this.course_from_time, this.course_to_time);
      console.log("is reccurence ", this.is_course_recurring);
      console.log("is multidate ", this.multidate);
      console.log("course date", this.course_date);
      console.log(
        "start and end date ",
        this.course_start_date,
        this.course_end_date
      );
      console.log("recurrence ", this.recurrence);
      console.log("repeat ", this.repeat);
      console.log("occurs on ", this.occurs_on);
      console.log("occues on month", this.occurs_on_month);
      console.log();

      if (
        this.course_from_time == null ||
        this.course_from_time == "" ||
        this.course_to_time == null ||
        this.course_to_time == ""
      ) {
        this.invalid_time = true;
      } else {
        this.invalid_time = false;
      }
      if (this.price_per_session == "" || this.price_per_session == null) {
        this.invalid_session_price = true;
      } else {
        this.invalid_session_price = false;
      }
      if (this.location == "" || this.location == null) {
        this.invalid_location = true;
      } else {
        this.invalid_location = false;
      }
      if (
        this.is_course_recurring == 0 ||
        (this.is_course_recurring == 1 &&
          (this.recurrence.code == "no_fixed_time" ||
            this.recurrence == "no_fixed_time"))
      ) {
        if (
          this.course_date == null ||
          this.course_date == "" ||
          (Array.isArray(this.course_date) && this.course_date.length == 0)
        ) {
          this.invalid_date = true;
        } else {
          this.invalid_date = false;
          if (this.action == "create") {
            let current_date = new Date();
            current_date.setHours(0);
            current_date.setMinutes(0);
            current_date.setSeconds(0);
            current_date.setMilliseconds(0);
            // console.log(current_date);
            current_date = current_date.getTime();
            // console.log(current_date);
            // console.log(new Date(val).getTime());
            // console.log(new Date(val).getTime() - current_date);

            if (this.multidate == false) {
              var diff = new Date(this.course_date).getTime() - current_date;
              if (diff < 0) {
                this.invalid_select_date = true;
              } else {
                this.invalid_select_date = false;
              }
            } else {
              for (var i = 0; i < this.course_date.length; i++) {
                var diff =
                  new Date(this.course_date[i]).getTime() - current_date;
                if (diff < 0) {
                  this.invalid_select_date = true;
                  break;
                }
                if (i == this.course_date.length - 1) {
                  this.invalid_select_date = false;
                }
              }
            }
          }
        }
      } else if (
        this.is_course_recurring == 1 &&
        (this.recurrence.code != "no_fixed_time" ||
          this.recurrence != "no_fixed_time")
      ) {
        if (this.course_start_date == null || this.course_start_date == "") {
          this.invalid_start_date = true;
        } else {
          this.invalid_start_date = false;
          if (this.action == "create") {
            let current_date = new Date();
            current_date.setHours(0);
            current_date.setMinutes(0);
            current_date.setSeconds(0);
            current_date.setMilliseconds(0);
            // console.log(current_date);
            current_date = current_date.getTime();
            // console.log(current_date);
            // console.log(new Date(val).getTime());
            // console.log(new Date(val).getTime() - current_date);

            var diff =
              new Date(this.course_start_date).getTime() - current_date;
            if (diff < 0) {
              this.invalid_select_start_date = true;
            } else {
              this.invalid_select_start_date = false;
              if (
                (this.course_start_date != null &&
                  this.course_start_date != "" &&
                  this.course_end_date != null) ||
                this.course_end_date != ""
              ) {
                var diff =
                  new Date(this.course_end_date).getTime() -
                  new Date(this.course_start_date).getTime();
                if (diff <= 0) {
                  this.invalid_select_end_date = true;
                } else {
                  this.invalid_select_end_date = false;
                }
              }
            }
          }
        }
        if (this.course_end_date == null || this.course_end_date == "") {
          this.invalid_end_date = true;
        } else {
          this.invalid_end_date = false;
        }
        if (this.recurrence.code == "month" || this.recurrence == "month") {
          if (this.occurs_on_month == null || this.occurs_on_month == "") {
            this.invalid_occurs_on_month = true;
          } else {
            this.invalid_occurs_on_month = false;
          }
        } else if (
          this.recurrence.code == "week" ||
          this.recurrence == "week"
        ) {
          if (
            this.occurs_on.length == 0 ||
            this.occurs_on == null ||
            this.occurs_on == ""
          ) {
            this.invalid_occurs_on = true;
          } else {
            this.invalid_occurs_on = false;
          }
        }
      }
    },
    onSubmit(event) {
      console.log(event);
      console.log(this.event_type);
      console.log(this.cover_image);
      // console.log(this.preview);
      console.log(this.from_time, this.to_time);
      // console.log(JSON.stringify(this))
      this.is_loading = true;

      this.checkValidation();
      return;

      if (
        (!this.invalid_date &&
          !this.invalid_time &&
          !this.invalid_session_price &&
          !this.invalid_location &&
          !this.invalid_start_date &&
          !this.invalid_end_date &&
          !this.invalid_occurs_on &&
          !this.invalid_occurs_on_month &&
          this.action == "update" &&
          !this.invalid_select_end_date) ||
        (!this.invalid_date &&
          !this.invalid_time &&
          !this.invalid_session_price &&
          !this.invalid_location &&
          !this.invalid_start_date &&
          !this.invalid_end_date &&
          !this.invalid_occurs_on &&
          !this.invalid_occurs_on_month &&
          this.action == "create" &&
          !this.invalid_select_date &&
          !this.invalid_select_start_date &&
          !this.invalid_select_end_date)
      ) {
        if (this.cover_image != null && this.preview != null) {
          console.log("send img request");

          let formData = new FormData();
          formData.append("client", this.client_name);
          formData.append("selectedfile", this.cover_image);

          axios
            .post("filesmodule/upload", formData, {
              headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
                Authorization:
                  "Bearer " +
                  JSON.parse(window.localStorage.getItem("user")).access_token,
              },
            })
            .then((response) => {
              console.log(response);
              //this.is_loading = false;
              this.cover_image_id = response.data.id;
              this.getEventDataToSend();
            })
            .catch((error) => {
              console.log(error.response.data.error);
              console.log(error.request);
              console.log(error.message);
              this.$fire({
                // title: "Title",
                text: error.response.data.error,
                type: "error",
                timer: 5000,
                customClass: {
                  container: this.swal_container_class,
                  confirmButton: this.swal_confirm_button_class,
                },
              }).then((r) => {
                // console.log(r.value);
              });
            });
        } else {
          this.getEventDataToSend();
        }
      } else {
        this.is_loading = false;
      }
    },
    getEventDataToSend() {
      console.log("validated course data");
      console.log(this.client_name);

      let formData = new FormData();
      formData.append(
        "organizer_id",
        JSON.parse(window.localStorage.getItem("user")).id
      );
      formData.append("client", this.client_name);
      formData.append("type", this.event_type);
      formData.append("name", this.course_name);
      if (this.course_description != null) {
        formData.append("description", this.course_description);
      }
      if (this.cover_image_id != null) {
        formData.append("cover", this.cover_image_id);
      }
      formData.append("is_person", this.is_course_in_person);

      formData.append("capacity", this.capacity_per_session);
      formData.append("price_type", this.price_per_session);
      formData.append("price", this.amount);
      formData.append("location_type", "online");
      formData.append("address", this.location);
      formData.append("is_recurring", this.is_course_recurring);
      formData.append(
        "from",
        moment(this.course_from_time, "HH:mm:ss").format("HH:mm")
      );
      formData.append(
        "to",
        moment(this.course_to_time, "HH:mm:ss").format("HH:mm")
      );

      formData.append("recurrence", this.recurrence);

      if (this.is_course_recurring == 0) {
        formData.append(
          "dates[]",
          moment(this.course_date).format("yyyy-MM-DD")
        );
      } else if (this.is_course_recurring == 1) {
        if (
          this.recurrence == "no_fixed_time" ||
          this.recurrence.code == "no_fixed_time"
        ) {
          this.course_date.forEach((item) => {
            formData.append("dates[]", moment(item).format("yyyy-MM-DD"));
          });
        } else {
          formData.append("repeat_every", this.repeat);
          formData.append(
            "start_date",
            moment(this.course_start_date).format("DD-MM-yyyy")
          );
          formData.append(
            "end_date",
            moment(this.course_end_date).format("DD-MM-yyyy")
          );

          if (this.recurrence.code == "month" || this.recurrence == "month") {
            formData.append("month_days[]", this.occurs_on_month);
          } else if (
            this.recurrence.code == "week" ||
            this.recurrence == "week"
          ) {
            //  formData.append("week_days[]", this.occurs_on);
            this.occurs_on.forEach((item) => {
              formData.append("week_days[]", item);
            });
          }
        }
      }

      if (this.action === "create") {
        this.sendCreateCourseRequest(formData);
      } else if (this.action === "update") {
        this.sendUpdateCourseRequest(formData);
      }
    },
    sendCreateCourseRequest(formData) {
      axios
        .post("event/events", formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Course is created successfully",
            type: "success",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
            // timer: 3000,
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
    sendUpdateCourseRequest(formData) {
      console.log("in send update request " + this.event_id);
      console.log(formData.get("name"));
      formData.append("id", this.event_id);
      console.log(formData.get("id"));
      console.log(this.client_name);
      formData.append("_method", "put");

      axios
        .post("event/events/" + this.event_id, formData, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            client: this.client_name,
            Authorization:
              "Bearer " +
              JSON.parse(window.localStorage.getItem("user")).access_token,
          },
        })
        .then((response) => {
          console.log(response);
          this.$fire({
            // title: "Title",
            text: "Course is updated successfully",
            type: "success",
            timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
          this.is_loading = false;
          this.$router.go();
        })
        .catch((error) => {
          console.log(error.response);
          this.is_loading = false;
          this.$fire({
            // title: "Title",
            text: error.response.data.error,
            type: "error",
            // timer: 3000,
            customClass: {
              container: this.swal_container_class,
              confirmButton: this.swal_confirm_button_class,
            },
          }).then((r) => {
            // console.log(r.value);
          });
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/CourseInfo.vue